module.exports = __webpack_public_path__ + "img/building-img-color1.52be8b8f.png";